export function formatTimestampToDate(timestamp) {
    // 判断是否为秒级时间戳，常见的秒级时间戳数值小于 1e12
    if (timestamp < 1e12) {
        timestamp = timestamp * 1000;
    }
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * 将时间戳转换为包含日期和时间的字符串，格式为 YYYY-MM-DD HH:mm:ss
 * @param {number} timestamp - 时间戳，支持秒级和毫秒级
 * @returns {string} 格式化后的日期时间字符串
 */
export function formatTimestampToDateTime(timestamp) {
    // 判断是否为秒级时间戳，常见的秒级时间戳数值小于 1e12
    if (timestamp < 1e12) {
        timestamp = timestamp * 1000;
    }
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}  